<ng-container *ngIf="!!page">
    <tt-tabs #tabs>
        <tt-tab ttId="info" ttIcon="far fa-info-circle" ttLabel="h_info"></tt-tab>
        <tt-tab ttId="captask_prod_documents" ttIcon="far fa-file-alt" ttLabel="captaskresource_captask_prod_documents"></tt-tab>
        <tt-tab ttId="capjob_prod_documents" ttIcon="far fa-certificate" ttLabel="captaskresource_capjob_prod_documents"></tt-tab>
    </tt-tabs>
    <tt-documents [hidden]="tabs.ttSelectedId !== 'captask_prod_documents'" [params]="{ argtype: 'prod_id', argvalue: page.capjob_prod_keyno }"></tt-documents>
    <tt-documents [hidden]="tabs.ttSelectedId !== 'capjob_prod_documents'" [params]="{ argtype: 'prod_id', argvalue: page.captask_prod_keyno }"></tt-documents>
    <div class="tt-captaskresource__info" [hidden]="tabs.ttSelectedId !== 'info'">
        <tt-card ttHeading="gb_captaskresource_main_basis" ttTranslateHeading ttAccordion>
            <tt-input ttLabel="operation_name" [(ttModel)]="page.operation_name" ttReadonly></tt-input>
            <tt-textarea ttLabel="captask_prod_name" [(ttModel)]="page.captask_prod_name" ttReadonly></tt-textarea>
            <tt-input-number ttLabel="captaskresource_quantity_rest" [(ttModel)]="page.captaskresource_quantity_rest" ttTextAlign="right" ttDecimals="2" ttReadonly></tt-input-number>
            <tt-input ttLabel="postatus_name" [(ttModel)]="page.postatus_name" ttReadonly></tt-input>
            <tt-button-save
                *ngIf="canStartWorking"
                ttText="captaskresource_postatus_working"
                (ttClick)="setStatus('200')"
                [ttLoading]="settingStatus === '200'"
                [ttDisabled]="!!settingStatus"
            ></tt-button-save>
            <ng-container *ngIf="page.postatus_no === '200'">
                <tt-button-save ttText="captaskresource_postatus_planned" (ttClick)="setStatus('100')" [ttLoading]="settingStatus === '100'" [ttDisabled]="!!settingStatus"></tt-button-save>
                <tt-button-save ttText="captaskresource_postatus_finish" (ttClick)="setStatus('300')" [ttLoading]="settingStatus === '300'" [ttDisabled]="!!settingStatus"></tt-button-save>
            </ng-container>
        </tt-card>

        <tt-card ttHeading="gb_captaskresource_main_other" ttTranslateHeading ttAccordion>
            <tt-input ttLabel="equipment_name" [(ttModel)]="page.equipment_name" ttReadonly>
                <ng-container buttons>
                    <tt-form-field-button ttIcon="fas fa-chevron-right" ttGoto="equipmentedit" [ttGotoParms]="{ equipment_id: page.equipment_id }"></tt-form-field-button>
                </ng-container>
            </tt-input>
            <tt-input ttLabel="stocklocation_name" [(ttModel)]="page.stocklocation_name" ttReadonly></tt-input>
            <tt-textarea ttLabel="capjob_prod_name" [(ttModel)]="page.capjob_prod_name" ttReadonly></tt-textarea>
            <tt-input ttLabel="po_keyno" [(ttModel)]="page.po_keyno" ttReadonly>
                <ng-container buttons>
                    <tt-form-field-button ttIcon="fas fa-chevron-right" ttGoto="po" [ttGotoParms]="{ po_keyno: page.po_keyno }"></tt-form-field-button>
                </ng-container>
            </tt-input>
            <tt-input *ngIf="isPositiveNumber(page.order_internal_no)" ttLabel="order_order_no" [(ttModel)]="page.order_order_no" ttReadonly>
                <ng-container buttons>
                    <tt-form-field-button ttIcon="fas fa-chevron-right" ttGoto="orderhead" [ttGotoParms]="{ order_internal_no: page.order_internal_no }"></tt-form-field-button>
                </ng-container>
            </tt-input>
            <tt-input-number ttLabel="quantity" [(ttModel)]="page.quantity" ttTextAlign="right" ttDecimals="2" ttReadonly></tt-input-number>
            <tt-input-number ttLabel="quantity_finished" [(ttModel)]="page.quantity_finished" ttTextAlign="right" ttDecimals="2" ttReadonly></tt-input-number>
            <tt-datetime ttLabel="captaskresource_planned_start_dt" [(ttModel)]="page.captaskresource_planned_start_dt" ttReadonly></tt-datetime>
            <tt-datetime ttLabel="captaskresource_planned_end_dt" [(ttModel)]="page.captaskresource_planned_end_dt" ttReadonly></tt-datetime>
        </tt-card>

        <tt-card ttHeading="h_functions" ttTranslateHeading ttAccordion>
            <tt-button-goto
                ttText="captaskresource_captask_prod_documents"
                [ttBadge]="page.captask_prod_nbr_of_documents"
                ttGoto="documents"
                [ttGotoParms]="{ argtype: 'prod_id', argvalue: page.capjob_prod_keyno }"
            ></tt-button-goto>
            <tt-button-goto
                ttText="captaskresource_capjob_prod_documents"
                [ttBadge]="page.capjob_prod_nbr_of_documents"
                ttGoto="documents"
                [ttGotoParms]="{ argtype: 'prod_id', argvalue: page.captask_prod_keyno }"
            ></tt-button-goto>
            <tt-button-goto ttText="captaskresource_captaskplans" ttGoto="captaskplans" [ttGotoParms]="{ argtype: 'captaskresource_keyno', argvalue: page.captaskresource_keyno }"></tt-button-goto>
            <tt-button-goto
                *ngIf="isPositiveNumber(page.floating_location) && isPositiveNumber(page.stocklocation_keyno)"
                ttText="captaskresource_stockcontrolloclist"
                ttGoto="stockcontrolloclist"
                [ttGotoParms]="{ stocklocation_keyno: page.stocklocation_keyno }"
            ></tt-button-goto>
            <tt-button-goto ttText="captaskresource_pofinish" ttGoto="pofinishprod" [ttGotoParms]="{ po_keyno: page.po_keyno, p2_pofinishprod_keyno: '0' }"></tt-button-goto>
        </tt-card>
    </div>
</ng-container>
